import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Modal, Button } from "antd";
import esLocale from "@fullcalendar/core/locales/es";

const Calendario = ({ currentEvents, handleEventClick, selectedEvent, modalVisible, handleCerrarModalPacienteInfo, handleIrAPaciente }) => {
  const renderEventContent = (eventInfo) => {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
      </>
    );
  };

  return (
    <div className="col-lg-8 col-md-8">
      <div className="card">
        <div className="card-body">
          <div id="calendar">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              initialView="dayGridMonth"
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              events={currentEvents}
              select={handleEventClick}
              locale={esLocale}
              eventClick={(clickInfo) => handleEventClick(clickInfo)}
              eventContent={renderEventContent}
            />
            <Modal
              title={selectedEvent ? selectedEvent.title : ""}
              visible={modalVisible}
              style={{ zIndex: "10000" }}
              onCancel={handleCerrarModalPacienteInfo}
              footer={[
                <Button
                  key="goToPatient"
                  type="primary"
                  onClick={handleIrAPaciente}
                >
                  Ir a paciente
                </Button>,
                <Button
                  key="close"
                  onClick={handleCerrarModalPacienteInfo}
                >
                  Cerrar
                </Button>,
              ]}
              centered
            >
              <p>
                Fecha: {selectedEvent ? selectedEvent.startStr : ""}
              </p>
              <p>
                Responsable: {selectedEvent ? selectedEvent.extendedProps.responsable : ""}
              </p>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendario;
